var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name === 'android')?_c('FntAndroidIcon'):(_vm.name === 'ios')?_c('FntIosIcon'):(_vm.name === 'appgallery')?_c('FntAppgalleryIcon'):(_vm.name === 'rustore')?_c('FntRuStoreIcon'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }